export type SemanticTone =
  | "success"
  | "warning"
  | "danger"
  | "info"
  | "primary"
  | "muted"

export type ToneIntensity = "default" | "subtle"

export const tonePillClasses: Record<
  SemanticTone,
  Record<ToneIntensity, string>
> = {
  success: {
    default: "border-success/40 bg-success/15 text-success",
    subtle: "border-success/35 bg-success/12 text-success",
  },
  warning: {
    default: "border-warning/40 bg-warning/15 text-warning",
    subtle: "border-warning/35 bg-warning/12 text-warning",
  },
  danger: {
    default: "border-danger/40 bg-danger/15 text-danger",
    subtle: "border-danger/30 bg-danger/10 text-danger",
  },
  info: {
    default: "border-info/40 bg-info/15 text-info",
    subtle: "border-info/35 bg-info/12 text-info",
  },
  primary: {
    default: "border-primary/40 bg-primary/15 text-primary",
    subtle: "border-primary/25 bg-primary/8 text-primary",
  },
  muted: {
    default: "border-border bg-muted/60 text-muted-foreground",
    subtle: "border-border/70 bg-muted/40 text-muted-foreground",
  },
}

export function getToneClasses(
  tone: SemanticTone,
  intensity: ToneIntensity = "default",
): string {
  return tonePillClasses[tone][intensity]
}
